<template>
  <svg viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.52827 9.02827C0.26792 9.28862 0.26792 9.71073 0.52827 9.97108C0.78862 10.2314 1.21073 10.2314 1.47108 9.97108L5.47108 5.97108C5.73143 5.71073 5.73143 5.28862 5.47108 5.02827L1.47108 1.02827C1.21073 0.76792 0.78862 0.76792 0.52827 1.02827C0.267921 1.28862 0.267921 1.71073 0.52827 1.97108L4.05687 5.49967L0.52827 9.02827Z"
      fill="currentColor"
    />
  </svg>
</template>
<script>
import { Vue } from "vue-class-component";

export default class ChevronRightThin extends Vue {}
</script>
